/**
 * @author Ivan Torres
 */
import { __read } from "tslib";
import _parseStyle from './_parseStyle';
var EMPTY_OBJECT = {};
var _getStyle = function (utils) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var _a = __read(_parseStyle(utils, EMPTY_OBJECT, args), 1), styleObject = _a[0];
    return styleObject;
};
export default _getStyle;
